export default "__VITE_ASSET__Bz8H3Hpn__"